<template>
  <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 5V2C3 1.44772 3.44772 1 4 1H18C18.5523 1 19 1.44772 19 2V20C19 20.5523 18.5523 21 18 21H4C3.44772 21 3 20.5523 3 20V17M3 5H1.5M3 5V9M3 17H1.5M3 17V13M3 9H1.5M3 9V13M3 13H1.5M13 9C13 10.1046 12.1046 11 11 11C9.89543 11 9 10.1046 9 9C9 7.89543 9.89543 7 11 7C12.1046 7 13 7.89543 13 9ZM14 15.5C14.5523 15.5 15.0124 15.0455 14.8757 14.5104C14.6995 13.8203 14.3406 13.1837 13.8285 12.6716C13.0783 11.9214 12.0609 11.5 11 11.5C9.93918 11.5 8.92176 11.9214 8.17162 12.6716C7.65951 13.1837 7.3006 13.8203 7.12439 14.5104C6.98773 15.0455 7.44776 15.5 8.00004 15.5L14 15.5Z"
      stroke="#1C1C1C"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>
